export default __webpack_public_path__ + "static/media/arrow-title.5357bdaa.svg";